import { SearchCheck } from 'lucide-react';

import { ContentFindings } from '../components/ContentFindings';
import { ReportWrapper } from '../../report-shared/components';
import type { RiskIndicator } from '../types';

type ContentFindingsSectionProps = {
  contentRiskIndicators?: RiskIndicator[] | null;
};

export const ContentFindingsSection = ({ contentRiskIndicators }: ContentFindingsSectionProps) => {
  return (
    <ReportWrapper
      title="Content Findings"
      Icon={SearchCheck}
      tooltip="Analysis of website content for potential risk indicators and compliance issues."
      showTooltip={false}
    >
      <ContentFindings riskIndicators={contentRiskIndicators ?? []} />
    </ReportWrapper>
  );
};
